class LqdIconboxHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.handleDestroy();

    this.checkScaleAnimation();

    this.initAnimateIcon();
    this.initSlideOnHover();

  }

  getDefaultSettings() {
    return {
      selectors: {
        animateIconElement: '[data-animate-icon]',
        slideOnHoverElement: '[data-slideelement-onhover]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $animateIconElement: this.$element.find(selectors.animateIconElement),
      $slideOnHoverElement: this.$element.find(selectors.slideOnHoverElement),
    }
  }

  onElementChange(prop) {

    switch (prop) {
      case 'enable_scale_animation':
        this.checkScaleAnimation();
        break;
    
      default:
        break;
    }

  }

  checkScaleAnimation() {

    const scaleSetting = this.getElementSettings('enable_scale_animation');
    const classname = 'lqd-iconbox-scale';
    
    if ( scaleSetting === 'yes' ) {
      this.$element.addClass(classname);
    } else {
      this.$element.removeClass(classname);
    }

  }

  initAnimateIcon() {

    this.elements.$animateIconElement.liquidAnimatedIcon();

  }

  initSlideOnHover() {

    this.elements.$slideOnHoverElement.liquidSlideElement();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleAnimateIconDestroy();
    this.handleSlideElementDestroy();

  }

  handleAnimateIconDestroy() {

    if ( ! this.elements.$animateIconElement.length ) return;

    const animateIconData = this.elements.$animateIconElement.data('plugin_liquidAnimatedIcon');

    if ( animateIconData ) {
      animateIconData.destroy();
    }

  }

  handleSlideElementDestroy() {

    if ( ! this.elements.$slideOnHoverElement.length ) return;

    const slideElementData = this.elements.$slideOnHoverElement.data('plugin_liquidSlideElement');

    if ( slideElementData ) {
      slideElementData.destroy();
    }

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdIconboxHandler, { $element } );
};